import { Stack } from "@mui/material";
import { NumberCell } from "components/common/dataGrid";
import { useTenantTranslation } from "hooks/formatters";
import {
  InventoryTargetBound,
  InventoryTargetCopyScope,
} from "./ruleParameters";
import { InventoryTargetScopeMenu } from "./InventoryTargetScopeMenu";

export const InventoryTargetCell = ({
  scopes,
  quantity,
  bound,
  disabled,
  onCopy,
}: {
  scopes: InventoryTargetCopyScope[];
  quantity: number | null;
  bound: InventoryTargetBound;
  disabled: boolean;
  onCopy: (scope: InventoryTargetCopyScope) => void;
}) => {
  const { t } = useTenantTranslation();
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ width: "100%" }}
    >
      <NumberCell value={quantity} />
      {!disabled && quantity !== null && scopes.length > 0 ? (
        <InventoryTargetScopeMenu
          scopes={scopes}
          action="copy"
          label={t("autoCopyInventoryBound", {
            bound: t(bound === "min_quantity" ? "targetMin" : "targetMax"),
          })}
          onSelect={onCopy}
        />
      ) : null}
    </Stack>
  );
};
